<template>
    <span v-if="pristyp == 'timpris'">{{spotPris}}</span>
    <span v-if="pristyp == 'rörligt'">{{rorligt}}</span>
</template>

<script>

export default {
    props: { area: { type: String }, pristyp: {type: String} },
    data() {
        let spotPris = "";
        //let elcert = "";


        return {
            spotPris,
            rorligt: "",
            //elcert,
            timpris: 0,
        }


    },

    methods: {
        fetchPrice() {
            //fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=" + this.area + "&json", { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, })
            //    .then(res => res.json())
            //    .then(json => { console.log(json)
            //    })
            Promise.all([

                // fetch("https://api.gavleenergi.se/Elhandelsshop/HistoriskaElcertpriser").then(res => res.json()),
                // fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=" + this.area + "&json", { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json()),

                fetch("http://apitest.gavleenergi.se/elpriser?cc=GEAB&ed=" + this.area).then(res => res.json()),


            ])

                .then(json => {
                    //this.spotPris = json[1].content[0].prisetjustnu;
                    //
                    //let elcerts = json[0];
                    //let lastYear = elcerts[Object.keys(elcerts)[Object.keys(elcerts).length - 1]];
                    //let lastElcert = lastYear[lastYear.length - 1].split(",");
                    //this.elcert = lastElcert[1];
                    //
                    //console.log(lastElcert[1])
                    //console.log(this.spotPris)
                    //console.log((this.spotPris * 1) + (this.elcert * 1))
                    //
                    //this.timpris = Math.round(Number(this.spotPris) + Number(this.elcert) + Number(this.paslag))
                    //console.log(this.timpris)
                    this.spotPris = json[0][0].totalPriceIncMoms
                    this.rorligt = json[0][1].totalPriceIncMoms
                    console.log(json[0])


                })





        }


    },



    mounted() {


        this.fetchPrice()
    }
}


</script>